import React from "react";
import FamilyBreadCrumb from "./FamilyBreadCrumb";
import PropTypes from "prop-types";

const resultRenderer = ({
  name: stockDescription,
  barcode: stockCode,
  price,
  type,
  secondaryGrpDisplayName,
  tertiaryGrpDisplayName,
  productFamilyDisplayName,
  isMatched,
  alternativeBarcodes,
}) => {
  return (
    <div key={stockDescription}>
      <div>
        <b>({stockCode}) </b> {stockDescription}
        {alternativeBarcodes?.length > 0 && (
          <div style={{ paddingTop: 5 }}>
            <span style={{ color: "grey" }}>
              Alternative Codes:{" "}
              {alternativeBarcodes?.map((altCode, index) => {
                if (index === 0) {
                  return `${altCode}`;
                } else {
                  return `, ${altCode}`;
                }
              })}
            </span>
          </div>
        )}
        {isMatched && (
          <p style={{ color: "#66CB23", fontWeight: 700, marginTop: "0.5rem" }}>
            Matched
          </p>
        )}
      </div>
      {(secondaryGrpDisplayName ||
        tertiaryGrpDisplayName ||
        productFamilyDisplayName) && (
        <div>
          <FamilyBreadCrumb
            key={stockCode}
            {...{
              secondaryGrpDisplayName,
              tertiaryGrpDisplayName,
              productFamilyDisplayName,
            }}
          />{" "}
        </div>
      )}
    </div>
  );
};

resultRenderer.propTypes = {
  stockDescription: PropTypes.string,
  stockCode: PropTypes.string,
  price: PropTypes.number,
  type: PropTypes.string,
  secondaryGrpDisplayName: PropTypes.string,
  tertiaryGrpDisplayName: PropTypes.string,
  productFamilyDisplayName: PropTypes.string,
  isMatched: PropTypes.bool,
};

export default resultRenderer;
